import {Component, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PageComponent} from "../../../../core/shared/mvs-page/page.component";
import {MvsCoreService} from "../../../../core/shared/service/mvs-core.service";
import {HelpArticleDto} from "../../model/dto/help-article.dto";

/**
 * Page for viewing a single help article by slug.
 * Route: /lp/article/:slug
 */
@Component({
    selector: 'mvs-article-detail-page',
    templateUrl: './article-detail.page.html',
    styleUrls: ['./article-detail.page.scss'],
    standalone: false
})
export class LpArticleDetailPage extends PageComponent implements OnInit, OnChanges, OnDestroy {

    defaultLabel: string = "Artikel";
    slug: string;

    constructor(
        protected override route: ActivatedRoute,
        protected override coreService: MvsCoreService,
        private router: Router
    ) {
        super(route, coreService);
    }

    ngOnInit(): void {
        super.ngOnInit();
        this.initComponent();
    }

    /**
     * Initialize Component.
     */
    initComponent(): void {
        this.slug = this.route.snapshot.paramMap.get('slug');
        this.initialized = true;
    }

    /**
     * Process changes within Binding.
     * @param changes
     */
    ngOnChanges(changes: SimpleChanges): void {
        if (!this.initialized) {
            return;
        }
    }

    /**
     * Destroy component.
     */
    ngOnDestroy(): void {
    }

    onBack(): void {
        window.history.back();
    }

    onArticleNavigate(article: HelpArticleDto): void {
        this.router.navigate(['/lp/article', article.slug]);
        this.slug = article.slug;
    }
}
